module.exports = __webpack_public_path__ + "files/6863b18141bc78b73abb4448b6c6d6bd.png";